import { render, staticRenderFns } from "./NsContainer.vue?vue&type=template&id=274c7c70&scoped=true&"
import script from "./NsContainer.vue?vue&type=script&lang=js&"
export * from "./NsContainer.vue?vue&type=script&lang=js&"
import style0 from "./NsContainer.vue?vue&type=style&index=0&id=274c7c70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274c7c70",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NsIcon: require('/usr/app/src/components/ns/NsIcon.vue').default})
